import {Directive, ElementRef, EventEmitter, HostListener, Input, NgZone, Output} from "@angular/core";

@Directive({
    selector: "[numeric]"
})
export class NumericDirective {
    @Input("decimals") decimals = 0;
    @Input("negative") negative = 0;
    @Input("zeroAllow") zeroAllow = true;
    @Output() ngModelChange: EventEmitter<any> = new EventEmitter(false);

    private checkAllowNegative(value: string) {
        if (this.decimals <= 0) {
            return String(value).match(new RegExp(/^-?\d+$/));
        } else {
            var regExpString =
                "^-?\\s*((\\d+(\\.\\d{0," +
                this.decimals +
                "})?)|((\\d*(\\.\\d{1," +
                this.decimals +
                "}))))\\s*$";
            return String(value).match(new RegExp(regExpString));
        }
    }

    private check(value: string) {
        if (this.decimals <= 0) {
            return String(value).match(new RegExp(/^\d+$/));
        } else {
            var regExpString =
                "^\\s*((\\d+(\\.\\d{0," +
                this.decimals +
                "})?)|((\\d*(\\.\\d{1," +
                this.decimals +
                "}))))\\s*$";
            return String(value).match(new RegExp(regExpString));
        }
    }

    private run(oldValue) {
        setTimeout(() => {
            let currentValue: string = this.el.nativeElement.value;
            let allowNegative = this.negative > 0 ? true : false;

            if (allowNegative) {
                if (
                    !["", "-"].includes(currentValue) &&
                    !this.checkAllowNegative(currentValue)
                ) {
                    this.el.nativeElement.value = oldValue;
                }
            } else {
                if (currentValue !== "" && !this.check(currentValue)) {
                    this.el.nativeElement.value = oldValue;
                }
            }
        });
    }

    constructor(private el: ElementRef,
                private _ngZone: NgZone) {
    }

    @HostListener("keydown", ["$event"])
    onKeyDown(event: KeyboardEvent) {
        this.run(this.el.nativeElement.value);
    }

    @HostListener("blur", ["$event"])
    onBlur(event: KeyboardEvent) {
        // si el campo se encuentra vacio
        if (this.el.nativeElement.value == '') {
            if (this.zeroAllow) {
                this.el.nativeElement.value = '0.00';
            } else {
                this.el.nativeElement.value = '1.00';
            }
        }
        this.el.nativeElement.value = parseFloat(this.el.nativeElement.value);
        // si dejan el campo empezar por "."
        if (this.el.nativeElement.value.startsWith('.')) {
            if (this.zeroAllow) {
                this.el.nativeElement.value = '0' + this.el.nativeElement.value;
            } else {
                this.el.nativeElement.value = '1' + this.el.nativeElement.value;
            }
        }
        // si dejan el campo sin decimales
        if (this.el.nativeElement.value.indexOf('.') == -1) {
            this.el.nativeElement.value = this.el.nativeElement.value + '.00';
        }
        this._ngZone.run(() =>
            this.ngModelChange.emit(this.el.nativeElement.value));
    }

    @HostListener("paste", ["$event"])
    onPaste(event: ClipboardEvent) {
        this.run(this.el.nativeElement.value);
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/directive/numeric-directive.directive.ts